import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { articleOneDefinitionsTable } from './article-one-definitions/article-one-definitions'
import { summayContent } from './summary/summary-content'
import { Article } from '../shared/article'
import { List } from '../shared/article/list'
import { DefinitionTable } from '../shared/definition-table'
import { Summary } from '../shared/summary'

const TermsAndConditions = () => {
  const ContentTermsAndConditions = () => (
    <div className={s.conditions}>
      <div className={s.conditionsTitle}>
        <h1 className={s.heroTitle}>
          <FormattedMessage
            id='ui.TermsAndConditions.title'
            defaultMessage='CONDITIONS GENERALES D’UTILISATION'
          />
        </h1>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.lastUpdated'
            defaultMessage='Date de la dernière mise à jour : 04 août 2023'
          />
        </p>
      </div>
      <div className={s.summary} id='Summary'>
        <Summary summaryContent={summayContent} />
      </div>
      <Article summaryContent={summayContent[0]}>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentOne'
            defaultMessage="Outre les termes et expressions par ailleurs définis dans les présentes conditions générales d’utilisation,
          les termes et expressions ci-dessous précisées auront, pour leur application et interprétation, la
          signification qui leur est assignée ci-après, à moins qu'il n'en soit expressément stipulé
          autrement."
          />
        </p>
        <DefinitionTable tableContent={articleOneDefinitionsTable} />
      </Article>
      <Article summaryContent={summayContent[1]}>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentTwo.subcontentOne'
            defaultMessage='Les mentions légales du Site internet sont consultables à l’adresse suivante : {confidentiality}.'
            values={{
              confidentiality: (
                <a href='https://www.naboo.app/confidentialite'>
                  <FormattedMessage
                    id='ui.TermsAndConditions.summaryContentTwo.link'
                    defaultMessage='https://www.naboo.app/confidentialite'
                  />
                </a>
              ),
            }}
          />
        </p>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentTwo.subcontentTwo'
            defaultMessage='Pour toute question, le Client peut avoir au recours au chat disponible sur le Site ou grâce au numéro de
          téléphone et adresse email affichés sur le Site.'
          />
        </p>
      </Article>
      <Article summaryContent={summayContent[2]}>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentThree'
            defaultMessage=' Les présentes CGU ont pour objet de régir les conditions et modalités d’utilisation du Site et notamment les
          conditions dans lesquelles le Client y effectue des Demandes de réservation.'
          />
        </p>
      </Article>
      <Article summaryContent={summayContent[3]}>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentFour'
            defaultMessage='Le Client déclare avoir pris connaissance des présentes CGU et les avoir acceptées en cochant, lors de son
					inscription, la case prévue à cet effet. Il reconnaît avoir eu connaissance de la possibilité d’enregistrer
					et/ou imprimer les présentes CGU à partir du Site.'
          />
        </p>
      </Article>
      <Article summaryContent={summayContent[4]}>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentFive'
            defaultMessage='Les présentes CGU sont en vigueur entre les Parties à compter de leur acceptation par le Client et demeurent en vigueur tant que le Client dispose d’un Compte sur le Site.'
          />
        </p>
      </Article>
      <Article summaryContent={summayContent[5]}>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentSix'
            defaultMessage='Naboo se réserve le droit de modifier partiellement ou totalement les présentes CGU sous réserve d’en informer
          le Client dans un délai raisonnable.'
          />
        </p>
      </Article>
      <Article summaryContent={summayContent[6]}>
        {summayContent[6].subArticles && (
          <>
            <Article
              summaryContent={summayContent[6].subArticles[0]}
              isSubArticle={true}
            >
              <p>
                <FormattedMessage
                  id='ui.TermsAndConditions.summaryContentSeven.subArticleOne.subcontentOne'
                  defaultMessage='Naboo propose un service de réservation de Prestations de Voyages d’affaires en ligne permettant au	Client la réservation de Prestations de Voyages d’affaires auprès de Partenaires via le Site.'
                />
              </p>
              <p>
                <FormattedMessage
                  id='ui.TermsAndConditions.summaryContentSeven.subArticleOne.subcontentTwo'
                  defaultMessage=' Dans ce cadre, Naboo propose différentes Prestations de Voyages d’affaires au nom et pour le compte des
                Partenaires et incluant notamment l’hébergement, le transport, les services de restauration ainsi que
                des activités, étant précisé que le Client est libre de choisir une ou plusieurs Prestations de Voyages
                d’affaires.'
                />
              </p>
            </Article>
            <Article
              summaryContent={summayContent[6].subArticles[1]}
              isSubArticle={true}
            >
              <p>
                <FormattedMessage
                  id='ui.TermsAndConditions.summaryContentSeven.subArticleTwo.subcontentOne'
                  defaultMessage='Le contenu et les caractéristiques des Prestations de Voyages d’affaires proposées ainsi que leur disponibilité au moment de la réservation du Client sont décrites sur le Site sur la base des informations communiquées par les Partenaires.'
                />
              </p>

              <p>
                <FormattedMessage
                  id='ui.TermsAndConditions.summaryContentSeven.subArticleTwo.subcontentTwo'
                  defaultMessage='A cet égard et pour éviter toute ambiguïté, il est rappelé que Naboo agit en qualité de mandataire des
                Partenaires, sa responsabilité ne saurait être engagée à quelque titre que ce soit du fait d’une
                inexécution des Contrats d’application.'
                />
              </p>
            </Article>
          </>
        )}
      </Article>
      <Article summaryContent={summayContent[7]}>
        {summayContent[7].subArticles && (
          <>
            <Article
              summaryContent={summayContent[7].subArticles[0]}
              isSubArticle={true}
            >
              <p>
                <FormattedMessage
                  id='ui.TermsAndConditions.summaryContentEight.subArticleOne'
                  defaultMessage='Pour utiliser le Site, le Client garantit agir pour ses seuls Besoins professionnels et avoir conclu une
                Convention avec Naboo.'
                />
              </p>
            </Article>
            <Article
              summaryContent={summayContent[7].subArticles[1]}
              isSubArticle={true}
            >
              <p>
                <FormattedMessage
                  id='ui.TermsAndConditions.summaryContentEight.subArticleTwo.subcontentOne'
                  defaultMessage='L’accès au Site nécessite pour le Client de disposer d’un accès à Internet ainsi que du matériel
                informatique tel qu’un ordinateur ou un téléphone accompagné des logiciels habituellement nécessaires
                pour la navigation sur un site internet.'
                />
              </p>
              <p>
                <FormattedMessage
                  id='ui.TermsAndConditions.summaryContentEight.subArticleTwo.subcontentTwo'
                  defaultMessage='L’accès optimal au Site est conditionné par l’usage adéquat et le bon fonctionnement des équipements techniques du Client.'
                />
              </p>
              <p>
                <FormattedMessage
                  id='ui.TermsAndConditions.summaryContentEight.subArticleTwo.subcontentThree'
                  defaultMessage='Tous matériels et logiciels nécessaires à l’accès au Site restent exclusivement à la charge du Client.'
                />
              </p>
            </Article>
            <Article
              summaryContent={summayContent[7].subArticles[2]}
              isSubArticle={true}
            >
              <p>
                <FormattedMessage
                  id='ui.TermsAndConditions.summaryContentEight.subArticleThree.subcontentOne'
                  defaultMessage='Naboo accorde au Client un droit d’accès limité révocable, non exclusif, non cessible au Site en vue d’effectuer des Demandes de réservation pour ses seuls Besoins professionnels.'
                />
              </p>
              <p>
                <FormattedMessage
                  id='ui.TermsAndConditions.summaryContentEight.subArticleThree.subcontentTwo'
                  defaultMessage='Dans ce cadre, le Client déclare et garantit :'
                />
              </p>
              <List>
                <p>
                  <FormattedMessage
                    id='ui.TermsAndConditions.summaryContentEight.subArticleThree.subcontentThree'
                    defaultMessage='Utiliser le Site conformément aux usages, lois et réglementations applicables,'
                  />
                </p>
                <p>
                  <FormattedMessage
                    id='ui.TermsAndConditions.summaryContentEight.subArticleThree.subcontentFour'
                    defaultMessage='Utiliser le Site à des fins conformes aux présentes CGU, à la Politique de confidentialité, ainsi qu’aux lois et réglementations applicables,'
                  />
                </p>
                <p>
                  <FormattedMessage
                    id='ui.TermsAndConditions.summaryContentEight.subArticleThree.subcontentFive'
                    defaultMessage='Être titulaire de tous droits, autorisations, pouvoirs pour la navigation et l’inscription sur le Site.'
                  />
                </p>
              </List>
              <p>
                <FormattedMessage
                  id='ui.TermsAndConditions.summaryContentEight.subArticleThree.subcontentSix'
                  defaultMessage='Toute utilisation contraire du Site à sa finalité est strictement interdite et constitue une violation des présentes stipulations.'
                />
              </p>
            </Article>
            <Article summaryContent={summayContent[8]}>
              {summayContent[8].subArticles && (
                <>
                  {summayContent[8].subArticles[0].subArticles && (
                    <Article
                      summaryContent={summayContent[8].subArticles[0]}
                      isSubArticle={true}
                    >
                      <Article
                        summaryContent={
                          summayContent[8].subArticles[0].subArticles[0]
                        }
                        isSubArticle={true}
                      >
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleOne.subArticleOne.subcontentOne'
                            defaultMessage='Pour Utiliser le Service, le Client doit créer un Compte sur le Site.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleOne.subArticleOne.subcontentTwo'
                            defaultMessage='A cet effet, le représentant du Client doit renseigner son prénom, son nom ainsi que son email professionnel et sera invité à cliquer sur « S’inscrire ».'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleOne.subArticleOne.subcontentThree'
                            defaultMessage='Le Client recevra alors, sur l’email renseigné, une confirmation de son inscription.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleOne.subArticleOne.subcontentFour'
                            defaultMessage='Une fois son inscription confirmée, le Client pourra effectuer des Demandes de réservation sur le Site.'
                          />
                        </p>
                      </Article>
                      <Article
                        summaryContent={
                          summayContent[8].subArticles[0].subArticles[1]
                        }
                        isSubArticle={true}
                      >
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleOne.subArticleTwo.subcontentOne'
                            defaultMessage='Pour se connecter au Compte, le Client dispose d’un Identifiant personnel et confidentiel qui correspond à son adresse e-mail professionnel et d’un mot de passe personnel et confidentiel.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleOne.subArticleTwo.subcontentTwo'
                            defaultMessage='Le mot de passe choisi devra être conforme à la politique de sécurité de Naboo et sera valable pendant une période limitée. A l’issue de cette période, le mot de passe devra être modifié pour accéder au Site.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleOne.subArticleTwo.subcontentThree'
                            defaultMessage='Si le Client oublie son mot de passe, il pourra le récupérer en cliquant sur « Mot de passe oublié ? » sur la page de connexion du Site et recevra un email sur l’adresse email indiquée sur le Site lui permettant de le réinitialiser.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleOne.subArticleTwo.subcontentFour'
                            defaultMessage='Le Client est responsable de la confidentialité de son mot de passe et il garantit qu’il ne les divulguera pas à un tiers pour quelque raison que ce soit.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleOne.subArticleTwo.subcontentFive'
                            defaultMessage='Toute connexion au Compte à l’aide des Identifiants sera présumée être le fait du Client sauf faute exclusivement imputable à Naboo.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleOne.subArticleTwo.subcontentSix'
                            defaultMessage='Par conséquent, le Client supportera seul les conséquences du défaut de fonctionnement du Service consécutif à toute utilisation, par les membres de son personnel ou par toute personne auxquels le Client aura fourni les Identifiants et s’engage à réparer le préjudice subi par Naboo de ce fait.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleOne.subArticleTwo.subcontentSeven'
                            defaultMessage='Dans l’hypothèse d’une utilisation non autorisée du mot de passe par un tiers, le Client doit en informer immédiatement Naboo par tout moyen écrit. A réception de l’information écrite, Naboo :'
                          />
                        </p>
                        <List>
                          <p>
                            <FormattedMessage
                              id='ui.TermsAndConditions.summaryContentNine.subArticleOne.subArticleTwo.subcontentEight'
                              defaultMessage='suspendra immédiatement l’accès au Compte ;'
                            />
                          </p>
                          <p>
                            <FormattedMessage
                              id='ui.TermsAndConditions.summaryContentNine.subArticleOne.subArticleTwo.subcontentNine'
                              defaultMessage='adressera au Client un email lui permettant de restaurer son accès après vérification de son identité.'
                            />
                          </p>
                        </List>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleOne.subArticleTwo.subcontentTen'
                            defaultMessage='A défaut, et sauf faute de Naboo, toute connexion à l’aide des Identifiants sera réputée être effectuée par le Client qui supportera seul les conséquences de la perte du ou des Identifiants, Naboo ne pouvant en être tenue pour responsable sauf faute qui lui serait exclusivement imputable.'
                          />
                        </p>
                      </Article>
                      <Article
                        summaryContent={
                          summayContent[8].subArticles[0].subArticles[2]
                        }
                        isSubArticle={true}
                      >
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleOne.subArticleThree.subcontentOne'
                            defaultMessage='Le Client peut à tout moment supprimer son Compte, étant précisé que la suppression du Compte n’emporte pas la résiliation et plus généralement la cessation du ou des Contrats d’application en cours ou de la Convention.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleOne.subArticleThree.subcontentTwo'
                            defaultMessage='Naboo est en droit de supprimer le Compte en cas de cessation de la Convention pour quelque cause que ce soit.'
                          />
                        </p>
                      </Article>
                    </Article>
                  )}
                  {summayContent[8].subArticles[1].subArticles && (
                    <Article
                      summaryContent={summayContent[8].subArticles[1]}
                      isSubArticle={true}
                    >
                      <Article
                        summaryContent={
                          summayContent[8].subArticles[1].subArticles[0]
                        }
                        isSubArticle={true}
                      >
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleOne.subcontentOne'
                            defaultMessage='Le Client peut choisir les Prestations de Voyages d’affaires en cliquant sur l’onglet « La collection » présent sur le bandeau supérieur du Site ou « Tout explorer » sur la page d’accueil du Site.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleOne.subcontentTwo'
                            defaultMessage='Il peut également cibler sa recherche grâce à l’utilisation de filtres tels que le prix, le nombre de lits, le nombre de chambres, le type de lieu, l’ambiance, les équipements, le temps de transport, une piscine ou à l’aide de la géolocalisation via le « mode carte ».'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleOne.subcontentThree'
                            defaultMessage='Naboo propose un TOP 10 des Prestations de Voyages d’affaires les plus consultés sur le site.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleOne.subcontentFour'
                            defaultMessage='De même, grâce à l’onglet « Nos suggestions », le Client peut consulter les suggestions proposées par le commercial en charge du Client.'
                          />
                        </p>
                      </Article>
                      <Article
                        summaryContent={
                          summayContent[8].subArticles[1].subArticles[1]
                        }
                        isSubArticle={true}
                      >
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleTwo.subcontentOne'
                            defaultMessage='Pour effectuer une Demande de réservation de Prestations de Voyages d’affaires sur le Site, le Client se connecte à son Compte sur le Site et y sélectionne sa destination, la date d’arrivée, de départ et le nombre de Participants ainsi que le cas échéant une option d’arrivée anticipée et/ou de départ tardif.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleTwo.subcontentTwo'
                            defaultMessage='Le Client devra également renseigner un nom pour son Voyage d’affaires, un numéro de téléphone pour que le Partenaire puisse le contacter et confirmer ses options d’arrivée anticipée et/ou de départ tardif.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleTwo.subcontentThree'
                            defaultMessage='Pour finaliser sa Demande de réservation, le Client devra cliquer sur « Réserver ».'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleTwo.subcontentFour'
                            defaultMessage='Le Client peut également solliciter une demande d’accompagnement de la part de Naboo dans le cadre de sa Demande de réservation en cliquant sur « Envoyer une demande » ou en utilisant le formulaire mis à sa disposition sur la page d’accueil du Site.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleTwo.subcontentFive'
                            defaultMessage='Le Client devra alors renseigner ses dates de Voyage d’affaires, le nombre de Participants, le nombre de chambres minimum, le cas échéant une destination souhaitée, le budget et pourra préciser des informations complémentaires.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleTwo.subcontentSix'
                            defaultMessage='Pour certaines Demandes de réservation, le Client doit directement solliciter une Proposition commerciale en cliquant sur l’onglet prévu à cet effet. Il sera alors contacté par Naboo.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleTwo.subcontentSeven'
                            defaultMessage='En tout état de cause, pour être valable, la Demande de réservation devra comporter l’ensemble des informations utiles à son traitement.'
                          />
                        </p>
                      </Article>
                      <Article
                        summaryContent={
                          summayContent[8].subArticles[1].subArticles[2]
                        }
                        isSubArticle={true}
                      >
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleThree.subcontentOne'
                            defaultMessage='Une fois que le Client aura cliqué sur « Réserver » ou « Confirmer la réservation », un récapitulatif de la Demande de réservation s’affichera.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleThree.subcontentTwo'
                            defaultMessage=' Le Client pourra consulter le détail de son récapitulatif en cliquant sur les onglets
                          déroulants « Facture détaillée » et « Détail du voyage par Voyageur » ainsi que les
                          principales conditions d’annulation.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleThree.subcontentFour'
                            defaultMessage='Le Client pourra également vérifier et modifier ses choix en cliquant sur la flèche retour. Le Client pourra alors renseigner une nouvelle fois les informations nécessaires à la Réservation.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleThree.subcontentFive'
                            defaultMessage='Pour finaliser sa Réservation, le Client est invité à accepter la Convention ainsi que le Contrat d’application à l’aide des cases à cocher avant de cliquer sur « Confirmer et payer ».'
                          />
                        </p>
                      </Article>
                      <Article
                        summaryContent={
                          summayContent[8].subArticles[1].subArticles[3]
                        }
                        isSubArticle={true}
                      >
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleFour.subcontentOne'
                            defaultMessage='Sur la page suivante, le Client est invité à procéder au paiement.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleFour.subcontentTwo'
                            defaultMessage='Selon les conditions financières convenues avec le Partenaire dans le Contrat d’application, le Client peut être invité à régler un acompte ou la totalité du montant du Voyage d’affaires à la Réservation.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleFour.subcontentThree'
                            defaultMessage='Les Frais de service sont quant-à-eux payables à la Réservation.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleFour.subcontentFour'
                            defaultMessage='Le paiement s’effectue par carte bancaire (Carte bleue, Visa, Mastercard), virement ou prélèvement SEPA à l’aide d’un formulaire de transaction sécurisé selon les modalités précisées ci-après. La validation du paiement en cliquant sur l’icône « Réserver pour […] », emporte finalisation de la Réservation et conclusion du Contrat.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleFour.subcontentFive'
                            defaultMessage='Le Client pourra abandonner la réservation en cliquant sur l’onglet retour de la page.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleFour.subcontentSix'
                            defaultMessage='Le débit de la carte sera effectué au moment de la Réservation conformément à la somme indiquée lors de cette étape.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleFour.subcontentSeven'
                            defaultMessage='Il est précisé que pour effectuer son paiement par carte bancaire, le Client sera automatiquement redirigé vers le serveur monétique STRIPE.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleFour.subcontentEight'
                            defaultMessage='Dans l’hypothèse du paiement d’un acompte, le paiement du solde pourra se faire par virement, CB ou prélèvement SEPA.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleFour.subcontentNine'
                            defaultMessage='A cet égard, il est précisé que Naboo dispose d’un mandat de facturation et d’encaissement au nom et pour le compte des Partenaires.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleFour.subcontentTen'
                            defaultMessage='Dans tous les cas, la fourniture en ligne du numéro de carte bancaire ou de tout autre mode de paiement et la validation finale de la Réservation vaudront preuve de l’intégralité de ladite Réservation conformément aux articles 1125 et suivants du Code civil.'
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleFour.subcontentEleven'
                            defaultMessage='Dans l’hypothèse où la réservation est soumise à une vérification préalable par Naboo de la disponibilité d’une ou des Prestations de Voyages d’affaires, la validation de la commande n’emporte pas validation définitive de la Réservation. Naboo procédera aux vérifications nécessaires et contactera le Client pour confirmer la disponibilité de la ou des Prestations de Voyages d’affaires.'
                          />
                        </p>
                      </Article>
                    </Article>
                  )}
                </>
              )}
            </Article>
          </>
        )}
      </Article>
      <Article summaryContent={summayContent[9]}>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentTen.contentOne'
            defaultMessage='Naboo ne garantit pas que le Site sera disponible en continu.'
          />
        </p>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentTen.contentTwo'
            defaultMessage='Naboo pourra effectuer des opérations de maintenance pour assurer son bon fonctionnement. Les opérations de maintenance peuvent empêcher l’utilisation du Site pour une période limitée. En tout état de cause, le Client sera informé, si possible, des opérations de maintenance et de leurs durées approximatives.'
          />
        </p>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentTen.contentThree'
            defaultMessage='Naboo ne saurait être tenue responsable en cas de difficulté d’accès et/ou d’utilisation du Site dans le cadre de ces opérations de maintenance.'
          />
        </p>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentTen.contentFour'
            defaultMessage='Par ailleurs, le Site pourra être mis à jour régulièrement et parfois de manière automatique. Naboo fera ses meilleurs efforts pour que ces mises à jour n’aient pas d’effets sur l’utilisation du Site par le Client.'
          />
        </p>
      </Article>

      <Article summaryContent={summayContent[10]}>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentEleven.contentOne'
            defaultMessage='Le Client reconnaît que Naboo n’est pas en mesure de contrôler le transfert des données via le réseau de communication public en particulier s’agissant d’Internet. Le Client reconnaît et accepte que Naboo ne peut garantir la confidentialité des données transmises grâce aux moyens de communications publics.'
          />
        </p>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentEleven.contentTwo'
            defaultMessage='Par conséquent, le Client reconnaît que Naboo ne saurait être tenue responsable de tout préjudice résultant de difficultés d’accès et/ou d’utilisation du Site en raison notamment de perturbations du réseau Internet, des entreprises fournissant ledit réseau au Client, d’un encombrement du réseau Internet.'
          />
        </p>
      </Article>

      <Article summaryContent={summayContent[11]}>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentTwelve.contentOne'
            defaultMessage='L’accès au Site permet la consultation de l’ensemble des données appartenant à Naboo ou aux Partenaires pour le compte desquels elle agit et qui est mis à jour régulièrement. Naboo se réserve expressément, sans indemnisation, le droit de modifier à tout moment tout ou partie de ces données ou de le mettre à jour. Ainsi, Naboo pourra modifier la présentation, le support ou le contenu du Site. Le Client s’engage, quant à lui, à ne pas modifier de quelque manière que ce soit le contenu du Site.'
          />
        </p>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentTwelve.contentTwo'
            defaultMessage='L’ensemble des designs, textes, graphiques, images, vidéos, informations, logos, icônes-boutons, logiciels, fichiers audio, illustrations du Site sont protégés par le droit d’auteur de même que son architecture, sa présentation et son agencement.'
          />
        </p>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentTwelve.contentThree'
            defaultMessage="L'accès au Site n'entraîne aucun transfert de droit de propriété de quelque sorte que ce soit au bénéfice du Client. Il ne confère qu'une licence d’utilisation non exclusive, non transmissible à des tiers du Site au profit du Client formulée par validation des Identifiants."
          />
        </p>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentTwelve.contentFour'
            defaultMessage='Le Client s’interdit en outre de porter atteinte aux droits de reproduction, représentation et autres droits attachés aux données du Site. Le Client s’interdit de publier, diffuser ou vendre, de quelque manière que ce soit, les contenus protégés auxquels il accède. Plus généralement, il s’interdit de porter atteinte, directement, indirectement ou par l’intermédiaire de tiers, préposés ou collaborateurs, de quelque façon que ce soit, aux droits des auteurs de Naboo.'
          />
        </p>
      </Article>
      <Article summaryContent={summayContent[12]}>
        <FormattedMessage
          id='ui.TermsAndConditions.summaryContentThirteen'
          defaultMessage='La politique de collecte et de traitement des données personnelles est définie dans la Politique de
          confidentialité accessible sur ce lien : {confidentiality}.'
          values={{
            confidentiality: (
              <a href='https://www.naboo.app/confidentialite'>
                <FormattedMessage
                  id='ui.TermsAndConditions.summaryContentTwelwe.link'
                  defaultMessage='https://www.naboo.app/confidentialite'
                />
              </a>
            ),
          }}
        />
      </Article>
      <Article summaryContent={summayContent[13]}>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentFourteen.contentOne'
            defaultMessage='Les systèmes et fichiers informatiques font foi dans les rapports entre Naboo et le Client.'
          />
        </p>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentFourteen.contentTwo'
            defaultMessage='Ainsi, Naboo et le Client pourront valablement produire dans le cadre de toute procédure, aux fins de preuve les données, fichiers, programmes, enregistrements ou autres éléments, reçus, émis ou conservés au moyen des systèmes informatiques exploités par Naboo, sur tous supports numériques ou analogiques, et s’en prévaloir sauf erreur manifeste.'
          />
        </p>
      </Article>

      <Article summaryContent={summayContent[14]}>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentFifteen'
            defaultMessage='Le fait que l’une quelconque des stipulations des présentes CGU soit ou devienne illégale ou inapplicable n’affectera en aucune façon la validité ou l’applicabilité des autres stipulations des présentes.'
          />
        </p>
      </Article>

      <Article summaryContent={summayContent[15]}>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentSixteen.contentOne'
            defaultMessage='Les présentes CGU sont soumises au droit français.'
          />
        </p>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentSixteen.contentTwo'
            defaultMessage='En cas de différend lié aux présentes CGU, les Parties s`engagent à tenter de le résoudre amiablement.'
          />
        </p>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentSixteen.contentThree'
            defaultMessage={`A cet effet, la Partie la plus diligente envoie à l'autre Partie une demande de résolution à l'amiable du litige indiquant les éléments du litige et des suggestions pour résoudre ce litige à l'amiable (ci-après la "<b>Demande</b>").`}
            values={{
              b: (chunks) => <b>{chunks}</b>,
            }}
          />
        </p>
        <p>
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentSixteen.contentFour'
            defaultMessage="Si la Demande d'une Partie n'est pas résolue à l'amiable dans les trente (30) jours suivant sa réception par l'autre partie, le différend sera soumis à la compétence du Tribunal de Commerce de Paris y compris en cas d’action en référé, d’appel en garantie ou de pluralité de défendeurs."
          />
        </p>
      </Article>
    </div>
  )
  return <ContentTermsAndConditions />
}
export default TermsAndConditions
